import { FC } from 'react';
import { Dialog } from '@dynamon-as/ui';
import { useDynolang } from '@hooks';

export interface NavigationGuardModalProps {
    open: boolean;
    onConfirm: () => void;
    onClose: () => void;
}

const NavigationGuardModal: FC<NavigationGuardModalProps> = ({
    open,
    onConfirm,
    onClose,
}) => {
    const { t } = useDynolang('PAGE_COMMON');

    return (
        <Dialog
            open={open}
            title={t(
                'confirm_leave_title.label',
                'Er du sikker på at du vil forlate siden?',
            )}
            onConfirm={onConfirm}
            onClose={onClose}
            confirmText={t('confirm_leave.label', 'Ja, forlat siden')}
            cancelText={t('stay_on_page.label', 'Nei, bli på siden')}
        >
            <p style={{ color: 'red' }}>
                {t('changes_lost_warning.label', 'Alle endringer vil gå tapt.')}
            </p>
        </Dialog>
    );
};

export default NavigationGuardModal;
